import { ReactNode } from 'react';

import create from 'zustand';

interface FullSpinnerStore {
  isShow?: boolean;
  message?: ReactNode;
  showFullSpinner: (message?: ReactNode) => void;
  hideFullSpinner: () => void;
}

const initialState: Pick<FullSpinnerStore, 'message' | 'isShow'> = {
  isShow: false,
  message: undefined,
};

export const useFullSpinnerStore = create<FullSpinnerStore>((set) => ({
  ...initialState,
  showFullSpinner: (message) => set(() => ({ isShow: true, message })),
  hideFullSpinner: () => set(() => ({ isShow: false, message: undefined })),
}));
